import UploadBuktiTransfer from './UploadBuktiTransfer.vue'

export default UploadBuktiTransfer
